import { takeLatest, call, put } from 'redux-saga/effects';
import {
    GET_CONTRACT_REQUEST,
    GET_CONTRACTS_REQUEST,
    UPDATE_CONTRACT_REQUEST,
    CONFIRM_CONTRACT_REQUEST,
    DELETE_CONTRACT_REQUEST,
    COPY_CONTRACT_REQUEST,
    STOP_CONTRACT_REQUEST,
    SET_SCHOOL_COMMENT_REQUEST,
    CHANGE_CONTRACT_REQUEST, ACCEPT_CHANGE_CONTRACT_REQUEST,
} from '../constants/contractActionTypes';
import {
    getContractSuccess,
    getContractFailure,
    getContractsSuccess,
    getContractsFailure,
    updateContractSuccess,
    updateContractFailure,
    confirmContractSuccess,
    confirmContractFailure,
    deleteContractFailure,
    copyContractFailure,
    stopContractSuccess,
    stopContractFailure,
    setSchoolCommentSuccess,
    setSchoolCommentFailure,
    deleteContractSuccess,
    changeContractSuccess,
    acceptChangeContractSuccess, acceptChangeContractFailure
} from '../actions/contractActions';
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";
import {getSchoolYearsSuccess} from "../actions/jointPowersActions";
import {toast} from "react-toastify";

const getContract = (data) => {
    return apiCall(`${process.env.REACT_APP_API_URL}/contract-api/getContract`, 'POST', data);
}
const getContracts = (data) => {
    return apiCall(`${process.env.REACT_APP_API_URL}/contract-api/getContracts`, 'POST', data);
}
const updateContract = (data) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/updateContract`, 'POST', data);
const confirmContract = (data) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/confirmContract`, 'POST', data);
const deleteContract = (id) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/deleteContract/${id}`, 'GET');
const stopContract = (data) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/stopContract`, 'POST', data);
const setSchoolComment = (data) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/setSchoolComment`, 'POST', data);
const copyContract = (id) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/copyContract/${id}`, 'GET');
const changeContract = (id) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/changeContract/${id}`, 'GET');
const acceptChangeContract = (data) => apiCall(`${process.env.REACT_APP_API_URL}/contract-api/acceptChangeContract`, 'POST', data);

function* getContractSaga(action) {
    yield* handleApiRequest(action, getContract, getContractSuccess, getContractFailure);
}

function* getContractsSaga(action) {
    yield* handleApiRequest(action, getContracts, getContractsSuccess, getContractsFailure);
}

function* updateContractSaga(action) {
    yield* handleApiRequest(action, updateContract, updateContractSuccess, updateContractFailure);
}

function* confirmContractSaga(action) {
    yield* handleApiRequest(action, confirmContract, confirmContractSuccess, confirmContractFailure);
}

function* changeContractSaga(action) {
    yield* handleApiRequest(action, changeContract, changeContractSuccess, updateContractFailure);
}

function* acceptChangeContractSaga(action) {
    yield* handleApiRequest(action, acceptChangeContract, acceptChangeContractSuccess, acceptChangeContractFailure);
}

function* stopContractSaga(action) {
    yield* handleApiRequest(action, stopContract, stopContractSuccess, stopContractFailure);
}

function* setSchoolCommentSaga(action) {
    yield* handleApiRequest(action, setSchoolComment, setSchoolCommentSuccess, setSchoolCommentFailure);
}

function* deleteContractSaga(action) {
    const response = yield call(deleteContract, action.payload);
    if (response.error) {
        toast(response.error);
        yield put(deleteContractFailure(response.error));
    } else {
        toast(response.msg);
        yield put(getSchoolYearsSuccess(response.schoolYears));
        yield put(deleteContractSuccess(response.ID))
    }
}

function* copyContractSaga(action) {
    const response = yield call(copyContract, action.payload);
    if (response.error) {
        toast(response.error);
        yield put(copyContractFailure(response.error));
    } else {
        toast(response.msg);
        yield put(getSchoolYearsSuccess(response.schoolYears));
    }
}

export default function* watchContractSagas() {
    yield takeLatest(GET_CONTRACT_REQUEST, getContractSaga);
    yield takeLatest(GET_CONTRACTS_REQUEST, getContractsSaga);
    yield takeLatest(UPDATE_CONTRACT_REQUEST, updateContractSaga);
    yield takeLatest(CONFIRM_CONTRACT_REQUEST, confirmContractSaga);
    yield takeLatest(DELETE_CONTRACT_REQUEST, deleteContractSaga);
    yield takeLatest(COPY_CONTRACT_REQUEST, copyContractSaga);
    yield takeLatest(STOP_CONTRACT_REQUEST, stopContractSaga);
    yield takeLatest(SET_SCHOOL_COMMENT_REQUEST, setSchoolCommentSaga);
    yield takeLatest(CHANGE_CONTRACT_REQUEST, changeContractSaga);
    yield takeLatest(ACCEPT_CHANGE_CONTRACT_REQUEST, acceptChangeContractSaga);
}